'use strict';

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _themeSections = require('@shopify/theme-sections');

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

require('slick-carousel');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var selectors = {
  slider: '[data-hero-slider]',
  nav: '[data-hero-slider-nav]'
}; /* Register hero slider section to support multiple sliders on homepage */

(0, _themeSections.register)('hero-slider', {

  onLoad: function onLoad() {
    var _$$slick;

    // Get slider in section
    var sectionSlider = this.container.querySelector(selectors.slider);
    var sectionNav = this.container.querySelector(selectors.nav);
    // Initialize slick slider
    (0, _jquery2.default)(sectionSlider).slick((_$$slick = {
      dots: true,
      arrows: false,
      focusOnSelect: false
    }, (0, _defineProperty3.default)(_$$slick, 'dots', false), (0, _defineProperty3.default)(_$$slick, 'pauseOnHover', false), (0, _defineProperty3.default)(_$$slick, 'infinite', true), (0, _defineProperty3.default)(_$$slick, 'slidesToShow', 1), (0, _defineProperty3.default)(_$$slick, 'slidesToScroll', 1), (0, _defineProperty3.default)(_$$slick, 'speed', 1000), (0, _defineProperty3.default)(_$$slick, 'fade', true), (0, _defineProperty3.default)(_$$slick, 'cssEase', 'linear'), (0, _defineProperty3.default)(_$$slick, 'swipe', false), (0, _defineProperty3.default)(_$$slick, 'asNavFor', selectors.nav), (0, _defineProperty3.default)(_$$slick, 'draggable', false), (0, _defineProperty3.default)(_$$slick, 'autoplay', true), (0, _defineProperty3.default)(_$$slick, 'autoplaySpeed', 5000), _$$slick));

    (0, _jquery2.default)(sectionNav).slick({
      centerMode: true,
      focusOnSelect: true,
      slidesToShow: 5,
      dots: false,
      arrows: false,
      vertical: true,
      asNavFor: sectionSlider,
      draggable: false,
      speed: 150,
      infinite: true,
      responsive: [{
        breakpoint: 1280,
        settings: {
          settings: "unslick"
        }
      }]
    }).on("afterChange", function (event, slick, currentSlide, nextSlide) {
      var current = sectionNav.querySelector('.slick-current');
      setOpacity(current);
    }).on("beforeChange", function (event, slick, currentSlide, nextSlide) {
      resetOpacity(sectionNav);
    });

    var current = sectionNav.querySelector('.slick-center');
    resetOpacity(sectionNav);
    setOpacity(current);
  },

  // Switch to slide on block select
  onBlockSelect: function onBlockSelect(event) {
    var sectionSlider = this.container.querySelector(selectors.slider);
    var slideIndex = sectionSlider.querySelector('[data-block-id="' + event + '"]').getAttribute("data-slide");
    (0, _jquery2.default)(sectionSlider).slick('slickGoTo', parseInt(slideIndex));
  }

});

function setOpacity(current) {
  if (current.previousSibling) {
    current.previousSibling.classList.add('opacity-50');
    if (current.previousSibling.previousSibling) {
      current.previousSibling.previousSibling.classList.add('opacity-25');
    }
  }
  if (current) {
    current.classList.add('opacity-100');
  }
  if (current.nextSibling) {
    current.nextSibling.classList.add('opacity-50');
    if (current.nextSibling.nextSibling) {
      current.nextSibling.nextSibling.classList.add('opacity-25');
    }
  }
}

function resetOpacity(sectionNav) {
  sectionNav.querySelectorAll('.slick-slide').forEach(function (item) {
    item.classList.remove('opacity-25');
    item.classList.remove('opacity-50');
    item.classList.remove('opacity-100');
    item.classList.add('opacity-0');
  });
}